//++++++ マップ　初期設定 ++++
let map;
const main_icon = '/cmn/img/page_module/gmap/icon_main.png';
const sub_icon = '/cmn/img/page_module/gmap/icon_sub.png';
const default_y = 34.4445685;
const default_x = 132.9202678;
const default_zoom = 10;
let markers = [];

let spotsY = [];
let spotsX = [];





$(function () {
	//初期画面　描画
	initMap('all');


});



// ++++++++ マップ生成 ++++++++
function initMap(filter) {

	//++++++ マップ　初期化 +++++
	let defaultLatLng;
	markers = [];
	spotsY = [];
	spotsX = [];

	//マップセンター
	defaultLatLng = {
		lat: default_y,
		lng: default_x
	};

	const map = new google.maps.Map(document.getElementById("map"), {
		center: defaultLatLng,
		zoom: default_zoom,
	});



	//カウンター など変数
	let counter = 0;
	let flag = false;





	// ++++++++++ 周辺スポット　マーカー +++++++++
	for (let i = 0; i < spots.length; i++) {
		console.log('y');
		const this_number = String(i + 1);
		const spot = spots[i];
		const spot_title = spot[0];
		const spot_description = spot[0];
		const spot_y = spot[2];
		const spot_x = spot[3];
		const thisLatLng = new google.maps.LatLng(spot_y, spot_x);

		const spot_permalink = spot[4];
		const spot_thumb = spot[5];
		const spot_genre = spot[6];

		const spot_genre_array = spot_genre.split('/');

		const spot_area = spot[7];

		// fitBounds() 用　配列に追加
		spotsY.push(spot_y);
		spotsX.push(spot_x);

		if (filter == 'all') {
			flag = true;
			counter++;
		} else if (spot_genre.indexOf(filter, 0) !== -1) {
			flag = true;
			counter++;
		}
		//文字列に変換
		counter = String(counter);

		if (flag) {

			//インフォWindow HTML
			var spot_htm = '<div class="gmap_info_window">'
			spot_htm += '<h3 style="font-size:14px;font-weight:nomal;margin-bottom:0;"><a href="' + spot_permalink + '">' + spot_title + '</a></h3>';
			spot_htm += '</div>';

			//マーカ生成
			setMarker(map, spot_title, thisLatLng, spot_htm, 'spot_icon', 'sub', counter);
		}





	}





	//========== List HTMLの書き込み =============




	//========== マーカー座標にフィット =============

	//一覧配列が空の場合は実行しない
	if (spots.length) {

		const maxY = Math.max.apply(Math, spotsY);
		const minY = Math.min.apply(Math, spotsY);
		const maxX = Math.max.apply(Math, spotsX);
		const minX = Math.min.apply(Math, spotsX);

		const minYX = new google.maps.LatLng(minY, minX);
		const maxYX = new google.maps.LatLng(maxY, maxX);
		const latLngFit = new google.maps.LatLngBounds(minYX, maxYX);
		map.fitBounds(latLngFit);
	}




	//クラスター　オプション
	const mcOptions = {
		gridSize: 60,
		imagePath: "/cmn/img/page_module/gmap/clusta/m",
		iconWidth: 60,
		iconHeight: 60,
		isShowNum: true,
		averageCenter: true
	};
	//クラスターアイコン　生成
	const markerCluster = new MarkerClusterer(map, markers, mcOptions);






}



//マーカー生成　ファンクション
function setMarker(mapid, title, latlng, htm, icon_file, icon_type, number) {


	//マーカーオプション
	var marker = null;
	if (icon_type == 'sub') {
		marker = new google.maps.Marker({

			position: latlng,
			title: title,
			icon: sub_icon,
			label: {
				text: number,
				color: 'white',
				weight: 'bold'
			},
			map: mapid,
		});

	} else {
		marker = new google.maps.Marker({
			map: mapid,
			position: latlng,
			title: title,
			icon: main_icon,
			map: mapid,
		});

	}

	//オブジェクト作成
	var infoWindow = new google.maps.InfoWindow({
		content: name
	});

	//マーカーにリスナを登録
	markers.push(marker);
	google.maps.event.addListener(marker, 'click', function () {
		infoWindow.setContent(htm);
		infoWindow.open(mapid, marker);
	});


}